module.exports = __webpack_public_path__ + "static/paga-5d41775722add98866c4349a3985ed2e.svg";